import { sourceSystemEnum } from '../submodules/silverlight-common/lib/ts/src/common-enums/source.system.enums';

export default {
  General: {
    SYSTEM_NAME: sourceSystemEnum.PLC_APP,
    APP_INACTIVITY_TIMEOUT: 60 * 60 * 1000, // 60 minutes
    CLOSE_NOTIFICATION: 'Close',
    PLM_SYSTEM_NAME: sourceSystemEnum.PLM,
    PLCINFRA_SYSTEM_NAME: sourceSystemEnum.PLC_INFRA,
    REGEX: { EMAIL: /^(?!.*\.\.)(?!\.)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, ALPHANUMERIC: /^[a-zA-Z0-9]*$/, USERNAME: /^[A-Za-z0-9]{4,6}$/ }
  },

  Activity_Viewer: {
    TEXT_FILTER_VALUE: 'textFilterValue',
    EVENT_TYPE_FILTER_VALUE: 'eventType',
    TITLE: 'Activity Viewer',
  },

  Default_Homepage: {
    USER_MANAGEMENT_FEATURE_LABEL: 'User Management',
    ACTIVITY_VIEWER_FEATURE_LABEL: 'Activity Viewer',
  },

  Login: {
    USERNAME_OR_EMAIL_CONTROL: 'ctrlUsernameOremail',
    WELCOME_MESSAGE: 'Welcome',
    LOGIN_INSTRUCTIONS: 'Sign in to continue',
    SUBMIT_BUTTON: 'SIGN IN',
    LOGIN_ERROR: "Login failed. Please check your credentials and try again."
  },

  Not_Found: {
    ERROR_TITLE: 'Page not found',
    ERROR_DESCRIPTION:
      'Looks like the page you were looking for is no longer here...',
  },

  User_Add_Edit: {
    FREE_TEXT_MAX_LENGTH: 50,
    ADD_FORM_TYPE: 'add',
    EDIT_FORM_TYPE: 'edit',
    USERNAME_CONTROL: 'userName',
    ASSIGNED_ROLE_CONTROL: 'userAssignedRole',
    ASSIGNED_SYSTEM_CONTROL: 'userAssignedSystem',
    EMAIL_ID_CONTROL: 'userEmailId',
    PRODUCT_TYPE_CONTROL: 'userProductTypes',
    ORGANIZATION_NAME_CONTROL: 'userOrganizationName',
    COUNTRY_CONTROL: 'userCountry',
    REGION_CONTROL: 'userRegion',
    ALL_COUNTRY_REGION: 'ALL',
    INJECTOR_ID_CONTROL: 'injectorID',
    INJECTOR_TYPE_CONTROL: 'injectorType',
    LICENSE_DATE_TIME_CONTROL: 'userLicenseExpirationDateTime',
    PRODUCT_INJECTOR_IDS_CONTROL: 'userProductInjectorIDs',
    USER_TYPE_ENUM_KEYS: {
      FSE: 'FSE',
      BIOMED: 'BIOMED',
      DEALER: 'DEALER',
    },
    ADD_USER_SUCCESS: "User profile created successfully!",
    ADD_USER_ERROR: "Unable to create user",
    EDIT_USER_SUCCESS: "User profile updated successfully!",
    EDIT_USER_ERROR: "Unable to update user",
    FORM_VALIDATION_ERROR_REQUIRED: 'required',
    GET_INJECTOR_TYPES_ERROR: "Unable to get product info",
    GET_COUNTRY_LIST_ERROR: "Unable to get country/region info ",
    FSE_DEALER_EXP_DATE: () => {
      const currentDate = new Date();
      const futureDate = new Date();
      futureDate.setFullYear(currentDate.getFullYear() + 2);
      return futureDate;
    },
  },

  User_Bulk_Add: {
    ALL_COUNTRY_REGION: 'ALL',
    TITLE: 'Add Bulk Users',
    INSTRUCTION_HEADER:
      ' **** Please follow below instructions for adding users in bulk **** ',
    DOWNLOAD_TEMPLATE_INSTRUCTION:
      '1. Add new users in the given specified data format in BulkUser Template.',
    UPLOAD_TEMPLATE_INSTRUCTION:
      '2. Upload BulkUser Template file here after adding users in it.',
    DOWNLOAD_BUTTON: 'Download From Here',
    UPLOAD_BUTTON: 'Upload File',
    SUBMIT_BUTTON: 'Submit',
  },

  Grid: {
    GRID_TYPE: { USER: 'user', LOG: 'log' },
  },

  View_Modal: {
    ACTIVITY_TITLE: 'View Activity',
    USER_TITLE: 'View User',
  },
};
